import { type FC } from 'react'
interface MainButtonProps{
    action:any
    icon:any
    text:string
    size:string
    title:string
    disabled?:boolean
    dataTourId?: string
    hideTextDynamically?: boolean
}

export const MainButton: FC<MainButtonProps> = ({text, icon, action, size, title, disabled=false, dataTourId, hideTextDynamically=false}) => {
    return(
    <button
        data-tour-id={dataTourId}
        title={title}
        type="button"
        className={`inline-flex items-center gap-x-2 rounded-md bg-main-button px-3.5 py-2.5 text-sm font-semibold text-main-button-text shadow-sm hover:bg-main-button-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 overflow-hidden ${size} justify-center disabled:opacity-50 disabled:cursor-not-allowed`}
        onClick={action}
        disabled={disabled}
    >
        <span className={hideTextDynamically ? 'hidden md:block' : ''}>{text}</span>
        {icon}
    </button>
)
}
